import Vue from 'vue'

Vue.mixin({
  methods: {
    redirectBack (path) {
      if (this.$store.state.redirectPath) {
        this.$router.push(this.$store.state.redirectPath)
      } else {
        this.$router.push(path)
      }
    }
  }
})
